import { render } from "./SepaDirectDebits.vue?vue&type=template&id=5ce0770d"
import script from "./SepaDirectDebits.vue?vue&type=script&lang=js"
export * from "./SepaDirectDebits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__